import { render } from "./stat_fr_new.vue?vue&type=template&id=5ce5632c"
import script from "./stat_fr_new.vue?vue&type=script&lang=js"
export * from "./stat_fr_new.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__